import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createKanbanCategoryAction } from "../actions/createKanbanCategories.action";

export const useCreateKanbanCategory = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (vars: { name: string; kanbanPageUid: string }) =>
            createKanbanCategoryAction(vars.name, vars.kanbanPageUid),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["kanban-categories"] });
        },
    });
};
